module.exports = __webpack_public_path__ + "static/media/5.175e82dd.jpg";